<template>
    <li
        class="flex flex-col min-w-36 cursor-pointer"
        :class="{ 'pointer-events-none opacity-50': !isAvailable }"
        :aria-disabled="!isAvailable"
    >
        <div class="relative size-36">
            <item-image
                v-if="item.image"
                :item="item"
                :size="imageSize"
                :largeImages="largeImages"
                :eager-load="shouldEagerLoad"
            />
            <div
                v-else
                class="relative size-36 rounded-md border-2 border-gray-500 overflow-hidden"
            >
                <div
                    class="absolute w-[150%] h-0.5 bg-gray-500 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 -rotate-45"
                />
            </div>
            <quick-add-context
                v-if="!allergenDisabled && !visualMenu"
                :item="item"
                :is-expandable="!hasModifier && !requiresAgeVerification"
                class="absolute top-[105px] left-[105px] scale-[0.7]"
                @increment="quickAddToCartWithDelay($event)"
                @decrement="removeProductFromCart"
            />
        </div>
        <div class="overflow-hidden truncate max-w-36 leading-tight mt-1">
            <h3
                class="font-heading truncate text-base text-heading leading-none font-semibold"
            >
                {{ item.name }}
            </h3>
            <div
                v-if="item.price || !item.modifierGroups?.length"
                class="text-sm"
            >
                <span v-if="item.compareAtPrice">
                    <s class="mr-1 text-price">
                        {{ (item.compareAtPrice / 100) | customCurrency }}
                    </s>

                    {{ (item.price / 100) | customCurrency }}
                </span>

                <span v-else>
                    {{ (item.price / 100) | customCurrency }}
                </span>
            </div>
            <span class="text-muted text-sm leading-none">
                {{ item.description }}
            </span>
        </div>
    </li>
</template>

<script>
import QuickAddContext from './QuickAddContext';
import ItemImage from './MenuItemListItemImage';
import MenuItem from '@/components/MenuItem.vue';

export default {
    name: 'PopularItem',
    extends: MenuItem,
    components: {
        ItemImage,
        QuickAddContext
    }
};
</script>
